export function items(state) {
    return state.items.data
}

export function columns(state) {
    return state.items.columns
}
export function getStatus(state) {
    return state.status
}